module.exports = __webpack_public_path__ + "img/hikari_fisica_quon.71df0231.png";